import { useState } from 'react';
import { Tooltip, Typography } from '@mui/material';
import HelpOutlineSharpIcon from '@mui/icons-material/HelpOutlineSharp';

interface ClickableHelpTextProps {
  helpText: string | JSX.Element;
}

const ClickableHelpText = ({
  helpText
}: ClickableHelpTextProps): JSX.Element => {
  const [openTooltip, setOpenTooltipValue] = useState(false);

  const toggleClick = () => {
    setOpenTooltipValue(!openTooltip);
  };

  return (
    <Tooltip
      onClose={toggleClick}
      open={openTooltip}
      title={
        <Typography sx={{ whiteSpace: 'pre-line' }} component='text'>
          {helpText}
        </Typography>
      }
      arrow
      PopperProps={{
        disablePortal: true
      }}
      disableFocusListener
      disableHoverListener
      disableTouchListener>
      <span data-testid='tooltip'>
        <HelpOutlineSharpIcon onClick={toggleClick} />
      </span>
    </Tooltip>
  );
};

export default ClickableHelpText;
